import React from "react";
import {Button, Card, Flex} from "antd";


export const ExportMenuComponent: React.FC = () => {
    return (
        <Card>
            <Flex gap="middle">
            <Button
                href={"/api/export_restaurant_menu_file"}
                target="_blank"
                type={"primary"}
                ghost> Экспортировать меню ресторана
            </Button>
            <Button
                href={"/api/export_delivery_menu_file"}
                target="_blank"
                type={"primary"}
                ghost> Экспортировать меню доставки
            </Button>
                </Flex>
        </Card>
    )
}
